<!-- Enroll in a Course-->
<section>
    <div class="container content-box text-center">
        <h1>Add Course</h1>

        <!-- Course Enroll Form -->
        <form name="form" class="" (submit)="f.form.valid && onSubmit() " #f="ngForm" novalidate>

            <!-- Course -->
            <div class="row col-sm-12">
                <label for="course" class="col-sm-3 text-end mt-2">Course </label>
                <select class="col-sm-7 form-control " id="course" name="course" [(ngModel)]="courseInfo.course" #course="ngModel" [ngClass]="{ 'is-invalid': f.submitted && course.invalid }" required>
                    <option value="" selected="selected" disabled="disabled">-- select one --</option>
                    <option value="RentWise">RentWise (Renters)</option>
                    <option value="Fair Housing Education">Housing Provider Education (Housing Providers)</option>
                </select>

                <!-- Invalid Course -->
                <div *ngIf="f.submitted && course.invalid" class="invalid-feedback">
                    <div class="mb-1 text-center" *ngIf="course.errors!.required">Course is required</div>
                </div>
            </div>

            <!-- FHE Doesn't Need Agency -->
            <div *ngIf="courseInfo.course  == 'RentWise'">
                <div class="row col-sm-12 mt-2">
                    <label for="agency" class="col-sm-3 text-end mt-2">Agency </label>
                    <select class="col-sm-7 form-control" id="agency" name="agency" [(ngModel)]="courseInfo.agency" #agency="ngModel" [ngClass]="{ 'is-invalid': f.submitted && agency.invalid}" required>
                        <option value="" selected="selected" disabled="disabled">-- select one --</option>
                        <option *ngFor="let item of agencies.agencies" [value]="item.agencyName">
                            {{item.agencyName}}
                          </option>
                    </select>

                    <!-- Invalid Agency -->
                    <div *ngIf="f.submitted && agency.invalid" class="invalid-feedback">
                        <div class="mb-1 text-center" *ngIf="agency.errors!.required">Agency is required</div>
                    </div>

                </div>

                <!-- Agency Code -->
                <!-- <div class="row col-sm-12 mt-2" *ngIf="courseInfo.agency == 'Other'">
                    <p class="mt-2 mb-0">Don't see your agency? Enter their code:</p>
                    <label for="agency" class="col-sm-3 text-end mt-1">Code </label>
                    <input type="text" class="col-sm-7 form-control" id="code" name="code" [(ngModel)]="courseInfo.code" #code="ngModel" [ngClass]="{ 'is-invalid': f.submitted && agency.invalid }" placeholder="######" minlength="6">
                </div> -->
            </div>

            <!-- Submit -->
            <button type="submit" class="btn waves-dark mt-4">Enroll</button>
        </form>
    </div>
</section>
